<template>
  <div 
    class="note-item" 
    @click="$emit('click', note)"
    :class="{ failed: note.status === 3 }"
  >
    <div class="note-icon">
      <div class="icon-container" :class="getIconClass(note.filetype)">
        <i class="note-type-icon">{{ getIcon(note.filetype) }}</i>
      </div>
    </div>
    
    <div class="note-content">
      <h3 class="note-title" :class="{ error: note.status === 3 }">
        {{ note.notename || 'Untitled Note' }}
      </h3>
      <p class="note-date">{{ formatDate(note.createtime) }}</p>
    </div>
    
    <div class="note-actions">
      <div 
        v-if="note.status === 3" 
        class="error-badge"
      >
        Failed
      </div>
      <button 
        class="menu-btn" 
        @click.stop="$emit('showMenu', note)"
      >
        <i class="menu-icon">⋯</i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteItem',
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  emits: ['click', 'showMenu'],
  methods: {
    getIcon(filetype) {
      const icons = {
        record: '🎤',
        audio: '🎵', 
        youtube: '📹',
        pdf: '📄',
        upload: '📎'
      }
      return icons[filetype] || '📝'
    },
    
    getIconClass(filetype) {
      return `icon-${filetype}`
    },
    
    formatDate(dateTime) {
      if (!dateTime) return ''
      
      const date = new Date(dateTime)
      const now = new Date()
      const diffTime = Math.abs(now - date)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      
      if (diffDays === 1) {
        return 'Today'
      } else if (diffDays === 2) {
        return 'Yesterday'
      } else if (diffDays < 7) {
        return `${diffDays - 1} days ago`
      } else {
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.note-item {
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 8px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:active {
    transform: scale(0.98);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  &.failed {
    border-left: 4px solid #ef4444;
  }
  
  .note-icon {
    margin-right: 12px;
    
    .icon-container {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      &.icon-record {
        background: linear-gradient(135deg, #10b981, #059669);
      }
      
      &.icon-audio {
        background: linear-gradient(135deg, #3b82f6, #1d4ed8);
      }
      
      &.icon-youtube {
        background: linear-gradient(135deg, #ef4444, #dc2626);
      }
      
      &.icon-pdf,
      &.icon-upload {
        background: linear-gradient(135deg, #8b5cf6, #7c3aed);
      }
      
      .note-type-icon {
        font-size: 20px;
        filter: brightness(1.2);
      }
    }
  }
  
  .note-content {
    flex: 1;
    min-width: 0;
    
    .note-title {
      font-size: 16px;
      font-weight: 600;
      color: #111827;
      margin: 0 0 4px 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      &.error {
        color: #ef4444;
      }
    }
    
    .note-date {
      font-size: 14px;
      color: #6b7280;
      margin: 0;
    }
  }
  
  .note-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .error-badge {
      background: #ef4444;
      color: white;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 600;
    }
    
    .menu-btn {
      width: 32px;
      height: 32px;
      border: none;
      border-radius: 8px;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.2s ease;
      
      &:active {
        background: #f3f4f6;
      }
      
      .menu-icon {
        font-size: 16px;
        color: #9ca3af;
        transform: rotate(90deg);
      }
    }
  }
}
</style> 